import { isEmpty, isNotEmpty } from 'ramda';

const useUserFormValidation = ({
  isEditMode,
  emailIsValid,
  isAdministration,
  selectedTeam,
  currentTeamIsDisabled,
  isSuperAdmin,
  emailAlreadyUsed,
  rolesDisplayed,
  rolesToUpdate,
  isConnectedUserSelected,
  userExistIsSuperAdmin,
  userIsTeamMember,
  selectedRole,
  adminRoleIsSelected,
  isValid,
  isPendingUser = false
}) => {
  // Basic validation
  const isEmailValid = isEditMode || (emailAlreadyUsed || emailIsValid);
  const mustSelectTeam = isAdministration && !selectedTeam;
  const disableRoleAndOfferSelect = currentTeamIsDisabled || mustSelectTeam;
  const disableForm = isSuperAdmin || !isEmailValid;
  // hasRoles no longer checks rolesToUpdate: a pending user may have displayed roles
  // without an existing rolesToUpdate — update validation is handled by teamMemberHasNoUpdate
  const hasRoles = emailAlreadyUsed || isNotEmpty(rolesDisplayed);
  // Confirm button
  const userIsNotValid = !hasRoles || !isEmailValid;
  const teamMemberHasNoUpdate = isEditMode && userIsTeamMember && isEmpty(rolesToUpdate);
  const disabledConfirmModalAdministration = userIsNotValid || isConnectedUserSelected || isPendingUser || teamMemberHasNoUpdate;
  const pendingUserHasNoRoles = isPendingUser && isEmpty(rolesDisplayed);
  const disabledConfirmModalTeam = userIsNotValid || isConnectedUserSelected || userExistIsSuperAdmin || (!userIsTeamMember && isEmpty(rolesDisplayed)) || pendingUserHasNoRoles || teamMemberHasNoUpdate;
  const disableConfirmModal = isAdministration ? disabledConfirmModalAdministration : disabledConfirmModalTeam;
  // Team field
  const disabledTeamSelect = isAdministration && disableForm;
  // Role field
  const disabledRoleSelect = disableRoleAndOfferSelect || disableForm;
  // Offer field
  const disabledOfferSelect = disabledRoleSelect || !selectedRole || adminRoleIsSelected;
  // Add role button
  const disabledAddRoleBtn = disableForm || !isValid;

  return {
    mustSelectTeam,
    disableRoleAndOfferSelect,
    disableForm,
    hasRoles,
    userIsNotValid,
    disabledConfirmModalAdministration,
    disabledConfirmModalTeam,
    disableConfirmModal,
    disabledTeamSelect,
    disabledRoleSelect,
    disabledOfferSelect,
    disabledAddRoleBtn
  };
};

export default useUserFormValidation;